import { Link } from "react-router-dom";
import { usePageMeta } from "../lib/seo";
import { Figure } from "../components/site/Figure";
import { QuietCTA } from "../components/site/QuietCTA";

const selectedWork = [
  { slug: "oakland-hills", src: "/photos/oakland-hills/oakland-hills-01-10-kitchen.jpg", alt: "Kitchen — Oakland Hills custom home by Sandquist Construction", caption: "Oakland Hills — Oakland, California", cell: "lg:col-span-7" },
  { slug: "berkeley-hills-claremont", src: "/photos/berkeley-hills-claremont/berkeley-hills-claremont-05-kitchen-island.jpg", alt: "Kitchen island — Berkeley Hills home near the Claremont by Sandquist Construction", caption: "Berkeley Hills near Claremont — Berkeley, California", cell: "lg:col-span-5 lg:col-start-8 lg:mt-24" },
  { slug: "berkeley-modern-loft", src: "/photos/berkeley-modern-loft/berkeley-modern-loft-01-757-stair-03.jpg", alt: "Sculptural stair — Berkeley Modern Loft by Sandquist Construction", caption: "Berkeley Modern Loft — Berkeley, California", cell: "lg:col-span-7 lg:col-start-3" },
];

export default function Home() {
  usePageMeta(
    "Sandquist Construction | Custom Home Builder — Berkeley & East Bay, Since 1989",
    "Berkeley general contractor building architect-designed custom homes across the East Bay. CA License #572537, licensed since 1989. Two to three projects at a time."
  );

  return (
    <main data-testid="home-page">
      <section className="max-w-[1200px] mx-auto px-6 lg:px-8 pt-16 sm:pt-24" data-testid="home-hero">
        <div className="grid grid-cols-1 lg:grid-cols-12">
          <h1 className="lg:col-span-9 font-display text-4xl sm:text-5xl lg:text-6xl text-ink tracking-tight" data-testid="hero-line">
            Custom homes in the Bay Area since 1989.
          </h1>
        </div>
      </section>

      <section className="max-w-[1200px] mx-auto px-6 lg:px-8 pt-16 sm:pt-24" data-testid="home-feature-figure">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-x-6 gap-y-8">
          <div className="lg:col-span-3">
            <p className="font-display text-xl sm:text-2xl text-ink">Everything from remodels to entire custom homes.</p>
            <Link
              to="/process"
              data-testid="how-rick-works-link"
              className="inline-block mt-5 font-label sc text-xs tracking-[0.18em] text-plaster hover:text-ink transition-colors duration-200"
            >
              How Rick works →
            </Link>
          </div>
          <div className="lg:col-span-9">
            <Figure
              eager
              tier="feature"
              src="/photos/napa-residence/napa-residence-02-04-deck-towards-dining-room-p-copy.jpg"
              alt="Deck toward the dining room — Napa Residence by Sandquist Construction"
              caption="Napa Residence — Napa, California"
              testId="hero-image"
            />
          </div>
        </div>
      </section>

      <section className="max-w-[1200px] mx-auto px-6 lg:px-8 pt-16 sm:pt-24" data-testid="home-quote">
        <div className="grid grid-cols-1 lg:grid-cols-12">
          <div className="lg:col-start-2 lg:col-span-9">
            <p className="font-display text-[2rem] sm:text-[2.5rem] leading-[1.25] text-ink" data-testid="quote-line">
              I am not a salesman that will pitch and then be out of sight.
            </p>
            <p className="mt-6 font-label sc text-sm tracking-[0.18em] text-inkmuted" data-testid="quote-attribution">
              — Rick Sandquist
            </p>
          </div>
        </div>
      </section>

      <section className="max-w-[1200px] mx-auto px-6 lg:px-8 pt-16 sm:pt-24" data-testid="selected-work">
        <div className="flex items-baseline justify-between border-t border-hairline pt-6">
          <h2 className="font-label sc text-sm tracking-[0.18em] text-inkmuted">Selected Work</h2>
          <Link to="/projects" className="font-label sc text-sm tracking-[0.18em] text-plaster hover:text-ink transition-colors duration-200" data-testid="all-projects-link">
            All Projects →
          </Link>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-x-6 gap-y-12 mt-12">
          {selectedWork.map((tile) => (
            <Link key={tile.slug} to={`/projects/${tile.slug}`} className={`group block ${tile.cell}`} data-testid={`featured-tile-${tile.slug}`}>
              <Figure
                src={tile.src}
                alt={tile.alt}
                tier="standard"
                caption={tile.caption}
                imgClassName="w-full aspect-[4/5] object-cover"
              />
            </Link>
          ))}
        </div>
      </section>

      <QuietCTA />
    </main>
  );
}
